export class BlockchainError extends Error {
  // This gives the error type safety
  private readonly typeName = 'BlockchainError'
  public readonly name = this.typeName

  private constructor(message: string) {
    super(message)
  }

  public static createGetLYXBalanceError(message: string): BlockchainError {
    return new BlockchainError(`Error while getting LYX balance: ${message}`)
  }
}
